function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "pin_svg__a",
  d: "M8.773 14.177a1.083 1.083 0 01-1.546 0C4.409 11.307 3 8.761 3 6.54 3 3.756 5.239 1.5 8 1.5s5 2.256 5 5.04c0 2.22-1.409 4.766-4.227 7.637zM8 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pin_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pin_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#pin_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#pin_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})));
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}
export default SvgPin;